import {Ref, ref} from 'vue';

export class EditorPanelStoreControllerClass {
	private static _instance: EditorPanelStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelStoreControllerClass());
	}

	private constructor() {}

	private _fullscreenPanelId: Ref<string | null> = ref(null);

	// getters

	fullscreenPanelId(): string | null {
		return this._fullscreenPanelId.value;
	}

	// mutations
	setFullscreenPanelId(panelId: string | null): void {
		this._fullscreenPanelId.value = panelId;
		setTimeout(() => {
			window.dispatchEvent(new Event('resize'));
		}, 0);
	}
}

export const EditorPanelStoreController = EditorPanelStoreControllerClass.instance();
